export const LEGAL_SOURCES = Object.freeze({
  cir2025_2547: 'https://eur-lex.europa.eu/eli/reg_impl/2025/2547/oj/eng',
  reg2023_956: 'https://eur-lex.europa.eu/eli/reg/2023/956/oj/eng',
  cir2025_2621: 'https://eur-lex.europa.eu/eli/reg_impl/2025/2621/oj/eng',
});

export const DEFAULT_REGULATION = 'cir2025_2547';

export const legalSourceUrl = (regulation) => LEGAL_SOURCES[regulation] ?? null;

const ROMAN = '(?:IV|V|I{1,3})';
const SUB = '\\([a-z0-9]+\\)';
const SINGLE_POINT = `[A-Z]\\.\\d+(?:\\.\\d+)*(?:${SUB})*(?:[–-]${SUB})?`;
const POINT = `${SINGLE_POINT}(?: §\\d+(?:[–-]\\d+)?)?`;
const POINT_LIST = `${POINT}(?:, ${POINT})*`;
const POINT_WORD = '(?:(?:point|section) )?';
const ANNEX = `Annex ${ROMAN}\\b`;

const ACT_TAIL = `(?:, ${ANNEX}(?:, Part [A-Z]\\b)?(?:, point \\d+(?:\\.\\d+)*(?:${SUB})*)?)?`;
const ACT_REGULATION = `(?:(?:Commission )?Implementing )?Regulation \\(EU\\) (?:2023/956|2025/2547|2025/2621)${ACT_TAIL}`;
const CBAM_REGULATION_NUMBER = '\\((?:EU|UE|ΕΕ)\\) 2023/956(?!\\d)';
const ARTICLE = `(?:Article|Art\\.?) \\d+(?:${SUB})*`;
const CIR_NUMBER = `CIR 2025/2547(?:,? (?:${ARTICLE}|${ANNEX}(?: ${POINT_WORD}${POINT_LIST})?|${POINT_WORD}${POINT_LIST}))?`;
const ANNEX_POINT = `${ANNEX} ${POINT_WORD}${POINT_LIST}`;
const POINT_OF_ANNEX = `point [A-Z](?:\\.\\d+)* of ${ANNEX}`;
const POINT_ONLY = `point ${POINT_LIST}`;
const BARE_POINT = `(?<![\\w.§])${SINGLE_POINT}(?![\\w.])`;

const COMMON_ALTERNATIVES = [
  ACT_REGULATION,
  CBAM_REGULATION_NUMBER,
  CIR_NUMBER,
  ANNEX_POINT,
  POINT_OF_ANNEX,
  POINT_ONLY,
];

export const CITATION_PATTERN = COMMON_ALTERNATIVES.join('|');
export const BARE_CITATION_PATTERN = [...COMMON_ALTERNATIVES, BARE_POINT].join('|');

const GUIDANCE_BEFORE =
  /(?:GD\d+a?|[Gg]uidance|KGN|ETS(?: template| checklist)?|Verifier guidance)[\s,;:]*$/;

const regulationOf = (match) => {
  if (match.includes('2023/956')) return 'reg2023_956';
  if (match.includes('2025/2621')) return 'cir2025_2621';
  return DEFAULT_REGULATION;
};

export const splitCitations = (text, { bare = false } = {}) => {
  if (typeof text !== 'string' || text === '') return [];
  const pattern = new RegExp(bare ? BARE_CITATION_PATTERN : CITATION_PATTERN, 'g');
  const parts = [];
  let cursor = 0;
  let match = pattern.exec(text);
  while (match) {
    const before = text.slice(Math.max(0, match.index - 16), match.index);
    if (!GUIDANCE_BEFORE.test(before)) {
      if (match.index > cursor)
        parts.push({ type: 'text', value: text.slice(cursor, match.index) });
      parts.push({ type: 'cite', value: match[0], regulation: regulationOf(match[0]) });
      cursor = match.index + match[0].length;
    }
    match = pattern.exec(text);
  }
  if (cursor < text.length) parts.push({ type: 'text', value: text.slice(cursor) });
  return parts;
};
